import { render } from "./protocol_inside_memorandum.vue?vue&type=template&id=aa9ac742"
import script from "./protocol_inside_memorandum.vue?vue&type=script&lang=js"
export * from "./protocol_inside_memorandum.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/inside/block/protocol_inside_memorandum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa9ac742"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa9ac742', __exports__)) {
    console.log('reload')
    api.reload('aa9ac742', __exports__)
  }
  
  module.hot.accept("./protocol_inside_memorandum.vue?vue&type=template&id=aa9ac742", () => {
    console.log('re-render')
    api.rerender('aa9ac742', render)
  })

}


export default __exports__